export const MaxStorageSizeBytes: number = 109951162777600; // 100TB
